const React = require('react');
const ReactDOM = require('react-dom');
const BrandBrick = require('./components/brand-brick');
const WalletBrick = require('./components/wallet-brick');
const CardPaymentBrick = require('./components/card-payment-brick');
const StatusScreenBrick = require('./components/status-screen-brick');
const PaymentBrick = require('./components/payment-brick');
const NotFound = require('./components/base-live-demo-component/components/NotFound');
const CheckoutProComponent = require('./components/checkout-pro');

const fillDemoComponents = (i18n, deviceType, lang, userData, platform, liveDemoId = 'BASE', isLoggedAccountATestUser, email, actualUrl, liveDemoConfig, brand) => {
  const components = {
    'brand-brick': (
      <BrandBrick
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
      />
    ),
    'wallet-brick': (
      <WalletBrick
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
        isLoggedAccountATestUser={isLoggedAccountATestUser}
        brand={brand}
      />
    ),
    'card-payment-brick': (
      <CardPaymentBrick
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
      />
    ),
    'status-screen-brick': (
      <StatusScreenBrick
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
        brand={brand}
      />
    ),
    'payment-brick': (
      <PaymentBrick
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
      />
    ),
    'checkout-pro': (
      <CheckoutProComponent
        i18n={i18n}
        deviceType={deviceType}
        lang={lang}
        email={email}
        actualUrl={actualUrl}
        userData={userData}
        platform={platform}
        liveDemoId={liveDemoId}
      />
    ),
  };

  const defaultComponent = <NotFound i18n={i18n} />;

  const getDemoComponent = (componentId) => {
    if (components[componentId] && liveDemoConfig?.sites?.includes(platform?.siteId?.toUpperCase())) {
      return components[componentId];
    }
    return defaultComponent;
  };

  setTimeout(() => {
    const containers = document?.querySelectorAll('div[live-demo-component-id]');
    containers?.forEach((container) => {
      const demoComponentId = container?.getAttribute('live-demo-component-id');
      const DemoComponent = getDemoComponent(demoComponentId);
      ReactDOM.render(DemoComponent, container);
    });
  }, 1000);
};

module.exports = { fillDemoComponents };
